import { Currency } from 'root-constants'

export const formatPrice = (price, currency) => {
  if (currency.toLowerCase() === Currency.KRW) {
    return Math.trunc(price)
  }

  return price
}
